<template>
  <div class="sdk_wrapper">
    <div class="sdk_container">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.sdk_wrapper {
  margin-top: 68px;
  width: 100%;
  // min-height: 600px;
  .sdk_container {
    width: 1200px;
    margin: 0 auto;
  }
}
</style>